import { useState } from 'react'
import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import SorterOrderOverview from 'orders/presentation/components/atoms/SorterOrderOverview/SorterOrderOverview'
import TemplateDetailModal from 'orders/presentation/components/molecules/TemplateDetailModal/TemplateDetailModal'

interface Props {
    progress: OrderProgressEntity
    /** Toggles the classification variant of the template detail modal. */
    isClassification: boolean
}

/**
 * Order overview header with the template "Ver detalles" link and its modal.
 *
 * Single source of truth for the template link so every detail view (sorter,
 * classification and containerless) shows it consistently. The link only opens
 * the modal when the order actually has a templateId.
 */
export default function OrderTemplateOverview({ progress, isClassification }: Props) {
    const [showModal, setShowModal] = useState(false)

    return (
        <>
            <SorterOrderOverview progress={progress} onViewTemplate={() => setShowModal(true)} />

            {showModal && progress.templateId && (
                <TemplateDetailModal
                    templateId={progress.templateId}
                    templateName={progress.templateName ?? ''}
                    isClassification={isClassification}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    )
}
